import {Pipe, PipeTransform} from '@angular/core';
import {environment} from "../../../environments/environment";

@Pipe({
  name: 'fastCoinsToDollar'
})
export class FastCoinToDollarPipe implements PipeTransform {

  fastCoinRate = 0.65;

  transform(value: number, ...args: unknown[]): string {
    // На проектах без F-coins (валюта = доллар, IS_FAST_COINS_ENABLED=false)
    // конвертация F-coins → $ не имеет смысла. Возвращаем пустую строку —
    // mat-tooltip с пустым содержимым не рендерится, поэтому пропадает
    // дублирующий «$ ...» в подсказках, которые во многих местах не закрыты
    // [matTooltipDisabled]="!isGoFast". Флаг — аналог IS_FAST_COINS_ENABLED
    // на бэке (см. backend-monorepo/libs/services/market/src/constants.ts).
    if (!environment.IS_FAST_COINS_ENABLED) return '';
    return `$ ${(value / 100 * this.fastCoinRate).toFixed(2)}`
  }

}
